/* React */
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

/* Components & dependencies */
import { Button, Icon, TablePagination } from "@mui/material";
import FullPageLoading from "../../FullPageLoading";
import LinearProgress from "@mui/material/LinearProgress";

/* Service */
import HotelesService from "../../../services/Hoteles.service";

import styles from "../layout.module.css";

const TablaHoteles = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [hoteles, setHoteles] = useState([]);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);

  useEffect(() => {
    loadPaquetes();
  }, [page, limit]);

  const loadPaquetes = async () => {
    setLoading(true);
    try {
      const results = await HotelesService.list(limit, page * limit);
      setHoteles(results.data);
      setTotal(results.total);
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      {loading ? (
        <FullPageLoading />
      ) : (
        <div className={styles.recentorders}>
          <div style={{ overflowX: "auto" }}>
            <table>
              <thead>
                <tr>
                  <td>
                    <h1 style={{ marginRight: "20px", marginBottom: "20px" }}>
                      Hoteles
                    </h1>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <Button
                      variant="outlined"
                      color="success"
                      onClick={() => navigate(`nuevo`)}
                    >
                      Nuevo
                    </Button>
                  </td>
                </tr>
              </thead>
              <thead>
                <tr>
                  <td style={{ fontWeight: "bold" }}>NOMBRE</td>
                  <td style={{ fontWeight: "bold" }}>DESCRIPCIÓN CORTA</td>
                  <td style={{ fontWeight: "bold" }}>CIUDAD</td>
                  <td style={{ fontWeight: "bold" }}>Habitaciones</td>
                  <td></td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                {hoteles.map((record, index) => {
                  const regex = /<[^>]'>/gim;
                  return (
                    <tr key={`${record.id}_${record.nombre}`}>
                      <td>{record?.nombre.replace(regex, "").slice(0, 30)}</td>
                      <td>
                        {record?.descripcionCorta
                          ?.replace(regex, "")
                          .slice(0, 30)}
                        ...
                      </td>
                      <td>
                        {record?.ciudad.replace(regex, "").slice(0, 50)}...
                      </td>
                      <td>
                        <span>ocupación</span>
                        <span
                          onClick={() => navigate(`${record.id}/habitaciones`)}
                        >
                          O
                        </span>
                      </td>
                      {/* <td>
                        <p>
                          {" "}
                          {(record.reservas * 100) / record.cupo}%{" "}
                          <LinearProgress
                            variant="determinate"
                            color="primary"
                            value={(record.reservas * 100) / record.cupo}
                          />{" "}
                        </p>
                      </td> */}

                      <td style={{ alignItems: "center", textAlign: "center" }}>
                        <span
                          onClick={() => navigate(`editar/${record.id}`)}
                          className="material-icons-sharp"
                        >
                          {" "}
                          edit{" "}
                        </span>
                      </td>
                      <td>
                        <span
                          className="material-icons-sharp"
                          onClick={() => navigate(`eliminar/${record.id}`)}
                        >
                          {" "}
                          delete{" "}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <TablePagination
            style={{ color: "var(--color-dark-variant)" }}
            component="div"
            labelRowsPerPage="Items por pagina"
            count={total}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={limit}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      )}
    </>
  );
};

export default TablaHoteles;
